/**
 * @param {string} str
 */
export default function lowerFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.charAt(0).toLowerCase() + str.slice(1);
}


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/lower-first.js
// module id = ld9E
// module chunks = 17